import { Fragment, jsx } from "react/jsx-runtime";
import { memo } from "react";
import { Grid, Row, Typography, theme } from "antd";
import Loader from "./../../loader/Loader.js";
import Video from "./video/Video";
import { useTranslation } from "@inscore/shared";
const { Text } = Typography;
const { useBreakpoint } = Grid;
const Videos = ({
  videos,
  loading,
  videoClickCallback,
  wrapperClassName = "",
  variant,
  leagueIconUrl
}) => {
  const { token } = theme.useToken();
  const screens = useBreakpoint();
  const { t } = useTranslation();
  const isFixture = variant === "fixture";
  const padding = isFixture ? !screens.md ? 12 : 20 : !screens.md ? 16 : 24;
  const gutter = isFixture ? 16 : 24;
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
    "div",
    {
      className: `${wrapperClassName}`,
      style: {
        padding
      },
      children: videos.length > 0 ? /* @__PURE__ */ jsx(Row, { gutter: [gutter, gutter], children: videos.map((video) => /* @__PURE__ */ jsx(
        Video,
        {
          video,
          videoClickCallback,
          variant,
          leagueIconUrl
        },
        video.id
      )) }) : loading ? /* @__PURE__ */ jsx(Loader, {}) : /* @__PURE__ */ jsx(
        Text,
        {
          type: "secondary",
          style: {
            color: token.colorTextBase,
            fontStyle: "italic"
          },
          children: t("no_videos_available")
        }
      )
    }
  ) });
};
var stdin_default = memo(Videos);
export {
  stdin_default as default
};
